import type { ApplicationType, MembershipTier, PartnerType, Role } from '@/types/domain';

/**
 * Dealership & partnership mock data.
 *
 * IMPORTANT: No discount rate, quota, deposit or payment advantage value is
 * defined here. Those are configured per class from the admin panel later.
 */

export interface MembershipModel {
  id: MembershipTier;
  labelKey: string;
  descKey: string;
  /** Application type pre-selected when the user clicks the card CTA. */
  applicationType: ApplicationType | null;
  highlight: boolean;
}

export const MEMBERSHIP_MODELS: MembershipModel[] = [
  {
    id: 'standard',
    labelKey: 'dealer.models.standard.name',
    descKey: 'dealer.models.standard.desc',
    applicationType: null,
    highlight: false,
  },
  {
    id: 'a',
    labelKey: 'dealer.models.a.name',
    descKey: 'dealer.models.a.desc',
    applicationType: 'dealer_a',
    highlight: true,
  },
  {
    id: 'b',
    labelKey: 'dealer.models.b.name',
    descKey: 'dealer.models.b.desc',
    applicationType: 'dealer_b',
    highlight: false,
  },
  {
    id: 'c',
    labelKey: 'dealer.models.c.name',
    descKey: 'dealer.models.c.desc',
    applicationType: 'dealer_c',
    highlight: false,
  },
];

export interface PartnerModel {
  id: PartnerType;
  labelKey: string;
  applicationType: ApplicationType;
}

export const PARTNER_MODELS: PartnerModel[] = [
  { id: 'distributor', labelKey: 'dealer.partners.distributor', applicationType: 'distributor' },
  { id: 'architect', labelKey: 'dealer.partners.architect', applicationType: 'architect' },
  { id: 'construction', labelKey: 'dealer.partners.construction', applicationType: 'construction' },
  { id: 'realtor', labelKey: 'dealer.partners.realtor', applicationType: 'realtor' },
  { id: 'other', labelKey: 'dealer.partners.other', applicationType: 'other' },
];

export const APPLICATION_TYPES: { value: ApplicationType; labelKey: string }[] = [
  { value: 'dealer_a', labelKey: 'dealer.models.a.name' },
  { value: 'dealer_b', labelKey: 'dealer.models.b.name' },
  { value: 'dealer_c', labelKey: 'dealer.models.c.name' },
  { value: 'distributor', labelKey: 'dealer.partners.distributor' },
  { value: 'architect', labelKey: 'dealer.partners.architect' },
  { value: 'construction', labelKey: 'dealer.partners.construction' },
  { value: 'realtor', labelKey: 'dealer.partners.realtor' },
  { value: 'other', labelKey: 'dealer.partners.other' },
];

/** Roles shown on the public role structure panel. */
export const PUBLIC_ROLES: Role[] = [
  'member',
  'dealer_a',
  'dealer_b',
  'dealer_c',
  'distributor',
  'architect',
  'construction',
  'realtor',
  'admin',
];